import { BrowserMultiFormatReader, Result } from '@zxing/library';
import { Modal } from 'bootstrap';

export class QRCodeScanner {
    private codeReader: BrowserMultiFormatReader;
    private stream: MediaStream | null = null;
    private modal: Modal | null = null;

    private readonly selectorModal = document.getElementById("modal-Scanner");
    private readonly videoElement: HTMLVideoElement | null = (document.getElementById('barcodeScanner') as HTMLVideoElement);

    constructor() {
        this.codeReader = new BrowserMultiFormatReader();
        if (this.selectorModal !== null) {
            this.modal = new Modal(this.selectorModal, { backdrop: 'static', keyboard: false });
        }
    }

    public async Init() {
        const that = this
        $('#modal-Scanner').on('hidden.bs.modal', function (e) {
            that.stopScanning();
        });
       
    }

    public async startScanning(): Promise<void> {
        try {
            this.modal?.show();
            $("#scanmessage").html("");
            const constraints: MediaStreamConstraints = {
                video: {
                    facingMode: 'environment', // Use the rear camera
                },
            };
            if (this.videoElement !== null) {

                this.stream = await navigator.mediaDevices.getUserMedia(constraints);
                this.videoElement.srcObject = this.stream;
                await this.videoElement.play();
            }
        } catch (error) {
            console.error('Camera initialization error:', error);
        }
    }



    public async stopScanning(message?: string): Promise<void> {
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
            if (message != null) {
                $("#scanmessage").html(message);
            }
        }
        if (message == null) {
            $("#scanmessage").html("");
            this.modal?.hide();
        }
    }

    public async scanBarcodeOrQRCode(): Promise<string | null> {
        try {
            if (this.videoElement !== null) {
                const result: Result = await this.codeReader.decodeOnce(this.videoElement);

                if (result) {
                    return result.getText();
                } else {
                    console.log('No code found.');
                }
            }
            return null;
        } catch (error) {
            console.error('Code detection error:', error);
            return null;
        }
    }
};